import { FormGroup, ValidationErrors } from '@angular/forms';

import { IObjectKeys } from '../../types';

export interface IFormError {
    control: string;
    error: string;
    value: unknown;
}

export function getFormValidationErrors(form: FormGroup): IFormError[] {
    const result: IFormError[] = [];
    Object.keys(form.controls).forEach(key => {
        const formProperty = form.get(key);
        if (formProperty instanceof FormGroup) {
            result.push(...getFormValidationErrors(formProperty));
        }
        const controlErrors: ValidationErrors | null | undefined = formProperty?.errors;
        if (controlErrors) {
            Object.keys(controlErrors).forEach(keyError => {
                result.push({
                    control: key,
                    error: keyError,
                    value: controlErrors[keyError]
                });
            });
        }
    });

    return result;
}

export function getFormErrorsAsObject(form: FormGroup) {
    const errors = getFormValidationErrors(form);

    const object = errors.reduce((acc: IObjectKeys, e: ValidationErrors) => {
        if (e['control'].indexOf('password') === -1 && e['control'].indexOf('pw') === -1) {
            acc[e['control']] = `${e['error']}`;
            acc[`${e['control']}_value`] = e['value'];
        }

        return acc;
    }, {});

    return object;
}
